<div id="pagConfig" class="page-layout simple">

  <!-- HEADER -->
  <div class="header primary p-16 p-sm-24"  fxLayout="row" fxLayoutAlign="space-between center">
      <div class="" fxLayout="row" fxLayoutAlign="start center">
        <button mat-icon-button class="mr-16" *ngIf="iframe" (click)="regresar()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
          {{'WEB_COMPANY_PROFILE.TIT_WCP' | translate}}
        </h1>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-icon-button class="mr-16" *ngIf="iframe" (click)="helpVideo()"  matTooltip="{{'WEB_COMPANY_PROFILE.HELP' | translate}}">
          <span class="material-icons-outlined">help_center</span>
        </button>
      <div>
        <ng-container *ngIf="statusWCP!=undefined">
          <mat-slide-toggle *ngIf="iframe" [checked]="statusWCP" [labelPosition]="labelPosition"  (change)="updateStatusVisibilityWCP($event)" >{{'WEB_COMPANY_PROFILE.ESTA_WEB_CP.'+statusWCP | translate}}</mat-slide-toggle>
        </ng-container>
      </div>
      </div>

  </div>
  <!-- / HEADER -->

  <!-- CONTENT -->
  <div class="content p-24 divPrincipal" id="Principal">

    <div fxLayout="column" fxLayoutAlign="center center" *ngIf="!iframe">
      <div class="courses" fxLayout="row wrap" fxLayoutAlign="center center" [@animateStagger]="{value:'50'}">
        <!--- lista de productos adquiridos --->
        <ng-container>
          <ng-container *ngIf="cargando">
            <div fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
              <div fxLayout="column" fxLayoutAlign="space-between center">
                <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                <h2>{{'WIZARD.CARGANDO' | translate}}</h2>
              </div>
            </div>
          </ng-container>
          <!-- RESULTADOS -->
          <ng-container *ngIf="!cargando && !cargandoInfoIframe">
            <div class="" fxLayout="row wrap" fxFlex="100">
              <div *ngIf="productosAsignados.length == 0" class="statusDiv" fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                  <h2>{{'WIZARD.SINPRODS' | translate}}</h2>
                  <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                </div>
              </div>
              <div *ngFor="let producto of productosAsignados; let i = index; let last = last; let first = first;" class="course" fxFlex="100" fxFlex.gt-sm="33" [ngClass]="web" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">

                <div class="cursoCard" fxFlex="100" [ngClass]="producto.category" [@animate]="{value:'*',params:{y:'100%'}}">
                  <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                    <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                    </div>

                    <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                      <div class="h1" >{{'WEB_COMPANY_PROFILE.PORDUC_CER.'+producto.idProducto | translate}} </div>
                      <div class="updated">{{'WIZARD.LANDING.DONE' | translate}}{{producto.fechaCertificar}}</div>
                      <div class="textFechaCierre">{{producto.fechaLanzamiento|date:'d MMM y':offsetPipe:idiomaActual}}</div>
                      <div class="textToken">{{producto.tokenConfig}}</div>
                      <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="instUtc==3">
                        <!-- <a mat-button style="margin-right:10px" class="mr-20 accent" href="https://www.google.com/" target="_blank" download>
                          BADGE
                        </a> -->
                        <button mat-button style="margin-right:10px"  class="accent" (click)="getBadgesWPC(producto.tokenConfig)">BADGE</button>
                        <button mat-button style="margin-right:10px"  class="accent" (click)="getGuideLinesWCP()">GUIDELINES</button>
                        <!-- <a mat-button class="mr-20 accent" href="https://www.google.com/" target="_blank" download>
                          GUIDELINES
                        </a> -->
                      </div>
                    </div>

                    <div class="footer" fxLayout="row" fxLayoutAlign="center center">

                      <button mat-button class="accent rndBt" fxFlex="100" (click)="navigateTo(producto.idCertificar);">{{'WIZARD.CERTIFICAR_C1.LANDING.ENTRAR' | translate}}</button>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div fxLayout="column" fxLayoutAlign="start stretch" *ngIf="iframe" class="ht100">
      <ng-container *ngIf="cargandoInfoIframe; else frameListo">
        <div fxLayout="column" fxLayoutAlign="start center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <div class="spinnerCGO"></div>
          <h2>{{'WIZARD.CARGANDO' | translate}}</h2>
        </div>
      </ng-container>
      <ng-template #frameListo>
        <div class="divIframe" *ngIf="urlCorrect">
          <form action="{{urlWebComProfile}}" method="post" id="RecDatos" target="frameTableau" >
          </form>
          <iframe name="frameTableau"></iframe>
        </div>
        <ng-container *ngIf="!urlCorrect">
          <div class="NO_FORALL" fxLayout="column" fxLayoutAlign="center center">
          <h1 class="h1 secondary-text"><p class="texto">{{textWarning}}</p></h1>
          </div>
        </ng-container>
      </ng-template>
      <div class="btnFlt" fxLayout="column" fxLayoutAlign="end end">
        <button mat-fab class="mr-16" *ngIf="iframe" (click)="helpVideo()" color="primary" matTooltip="{{'WEB_COMPANY_PROFILE.HELP' | translate}}">
          <span class="material-icons-outlined">help_center</span>
        </button>

      </div>
    </div>


</div>
<!-- / CONTENT -->

</div>
